import { FormControl, FormControlLabel, Checkbox } from "@material-ui/core";
import { useField, useFormikContext } from "formik";
export default function CheckboxField({
  required = false,
  options,
  name,
  label,
  fullWidth,
  commonProps = {},
  ...rest
}) {
  const [field, meta] = useField(name);
  const { value, ...other } = field;
  const formikContext = useFormikContext();
  const { isSubmitting: disabled } = formikContext;
  const errorMessage = meta.error && meta.touched ? meta.error : "";

  return (
    <>
      <div
        className={
          "d-flex flex-column input-margin appbar-div-investor-flow dual-margin-investor-flow"
        }
        style={fullWidth ? { gridColumn: "span 2" } : {}}
      >
        <FormControl fullWidth={fullWidth}>
          <FormControlLabel
            control={
              <Checkbox
                size="medium"
                color="primary"
                checked={value}
                disabled={disabled}
                {...other}
                {...rest}
              />
            }
            // color="blue"
            label={label}
          ></FormControlLabel>
        </FormControl>
        <div className="nps-error-message">{errorMessage}</div>
      </div>
    </>
  );
}
